import { Stack } from 'components/Stack';
import styled from 'styled-components';
import { mediaBreakpointUp } from 'styles/grid';

const desktopBreakpoint = mediaBreakpointUp.sm;

export const Container = styled(Stack)`
  padding: 16px 10px;
  ${desktopBreakpoint} {
    padding: 8px 16px;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
  }
`;
